/**
 * Typed wrapper for the documents-list endpoint.
 *
 *   GET /api/documents   → { documents, groups, group_label, ... }
 *
 * Used by the rail's document multi-select. Returns the full
 * document list (sorted alphabetically with "All Documents" pinned
 * at index 0) plus admin-defined topic groups (a curated subset
 * of documents).
 *
 * The endpoint also surfaces `enable_document_citation_view` -
 * we ignore it here because /api/platform/me already exposes the
 * same flag and the dashboard reads it from there.
 */
import { api } from './client';

export interface DocumentOption {
  id: string;
  title: string;
}

export interface DocumentGroup {
  /** Group id (used as the group's selectable filter token, prefixed). */
  id: string;
  name: string;
  /** Doc ids that belong to this group. The filter expands a group
   *  selection into its constituent doc ids before sending. */
  document_ids: string[];
}

export interface DocumentsResponse {
  documents: DocumentOption[];
  groups: DocumentGroup[];
  /** Human-friendly label for the groups section ("Topics" by
   *  default; tenant admin can rename). */
  group_label: string;
}

export function getDocuments(): Promise<DocumentsResponse> {
  return api<DocumentsResponse>('/api/documents');
}
